// SummaryCard.jsx
import React from 'react';
import i18n from '../../i18n';

class SummaryCard extends React.Component {
  render() {
    const { icon: Icon, label, amount, className, onClick, info } = this.props;

    return (
      <div
        className={`summary-card ${className} ${onClick ? 'summary-card-interactive' : ''}`}
        onClick={onClick}
        style={onClick ? { cursor: 'pointer' } : {}}
      >
        <div className="card-icon">
          <Icon size={24} />
        </div>
        <div className="card-content">
          <p className="card-label">{label}</p>
          <p className="card-amount">
            {amount}
            <span className="currency">{i18n.t('omr')}</span>
          </p>
          {/* {info && <p className="card-info">{info}</p>} */}
        </div>
      </div>
    );
  }
}

export default SummaryCard;
